@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/bb-chart.scss';

:host {
  color: var(--main-titles-inputs-600);
  padding-top: calc(var(--spacer) * 1.5);
}

.wrapper {
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  .chart-empty {
    display: none;
  }

  &.is-error,
  &.is-empty {
    .incidents-chart {
      display: none;
    }

    .chart-empty {
      display: flex;
      border-color: var(--grey-layout-203-dark-theme-disabled-text);
    }
  }

  &.is-loading {
    .chart-content,
    .chart-legend {
      display: none;
    }
  }
}

.widget-loading {
  bottom: calc(var(--spacer) * 3);
}

.content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  margin-top: calc(var(--spacer) * 3);

  .chart-legend {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-self: center;
    margin-right: auto;
  }

  .chart-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 160px;
    margin-bottom: calc(var(--spacer) * 2);

    .incidents-chart {
      width: 160px;
      height: 160px;
    }

    path {
      cursor: auto !important;
    }
  }

  .item-details {
    .gz-data-item {
      &--value {
        color: var(--main-titles-inputs-600);
      }
    }
  }

  &.threats-breakdown-container {
    flex-direction: column;
  }

  .bb-tooltip-container {
    padding: 0;
  }

  .bb-chart-arcs-title {
    fill: var(--main-titles-inputs-600);
  }

  .chart-tooltip {
    font-size: var(--tooltip-font-size);
    font-family: var(--font-family-secondary);
    color: var(--main-titles-inputs-600);
    background-color: var(--white-layout-303-level-2-elevation);
    box-shadow: 0px 0px 6px 0px var(--chart-050-hover);
    border-radius: calc(var(--spacer) * 0.5);
    padding: calc(var(--spacer) * 1.5) calc(var(--spacer) * 2);
    position: absolute;
    z-index: 2;
    transform: translate(-50%, -100%);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacer);
    min-width: 200px;
    span {
      font-family: var(--font-family-secondary);
    }

    .value {
      margin-left: auto;
    }
  }
}

@media screen and (max-width: 1600px) {
  .content {
    .chart-content {
      margin-right: 0;

      .incidents-chart {
        width: 130px;
        height: 130px;
      }
    }

    .incidents-list {
      .gz-data-item {
        &--title {
          margin-right: var(--spacer) !important;
        }
      }
    }
  }
}

:host([data-display-mode='pdf']) {
  .content {
    margin-top: calc(var(--spacer) * 2);

    .chart-content {
      transform: translate(-10px, -3px);
      width: 140px;
      height: 140px;
      margin-bottom: 3px;

      .incidents-chart,
      .donut-chart-error {
        width: 140px;
        height: 140px;
      }
    }
    .chart-legend {
      padding: 0;
      transform: translate(0px, 0px);
    }
    .gz-data-item {
      font-size: var(--body-size-xsmall);
      align-items: center;
    }

    .gz-data-item--value {
      font-size: var(--body-size);
    }
  }
}
